<!-- @format -->

@if (cards.length) {
	<div class="cards hmf-display-flex hmf-flex-col hmf-mx-s hmf-mx-md-0 hmf-mb-m">
		<p class="hmf-header-bold-s hmf-header-bold-md-m hmf-my-xs">Ready For Your Next Round?</p>

		@for (card of cards; track $index) {
			<div
				role="button"
				tabindex="0"
				(keydown.enter)="openQuickViewPanel(card.ecode)"
				class="card-button"
				(click)="openQuickViewPanel(card.ecode)"
				[attr.aria-label]="'Add ' + card.title">
				<div
					class="card hmf-display-flex hmf-align-items-center hmf-pl-xxs hmf-pl-md-xs hmf-pr-xs hmf-pr-md-s hmf-py-xxs hmf-mb-xs">
					<div class="card-product hmf-display-flex hmf-align-items-center">
						<div class="image-wrapper">
							<img
								class="image hmf-m-xxs"
								[src]="card.imageUrl"
								[alt]="card.title"
								(error)="card.imageUrl = UNAVAILABLE_IMAGE_URL" />
						</div>
						<div class="hmf-display-flex hmf-flex-col hmf-ml-xxs hmf-ml-md-s">
							<p class="title hmf-body-m">{{ card.title }}</p>
							<div class="hmf-display-flex hmf-align-items-center hmf-flex-wrap">
								@if (card.isSeePriceInCart) {
									<p class="hmf-body-bold-m hmf-body-bold-md-l hmf-mb-0">
										See Price In Cart
									</p>
								} @else {
									<p
										[ngClass]="{ 'clearance-price': card.isClearancePrice }"
										class="price hmf-body-bold-m hmf-body-bold-md-l hmf-mb-0">
										${{ card.prices?.minofferprice }}
										@if (card.hasOfferPriceRange) {
											<span> - ${{ card.prices?.maxofferprice }} </span>
										}
									</p>
									@if (card.isClearancePrice) {
										<p
											class="slashed-price price hmf-body-s hmf-body-md-m hmf-mb-0 hmf-ml-xxs">
											${{ card.prices?.minlistprice }}
											@if (card.hasListPriceRange) {
												<span> - ${{ card.prices?.maxlistprice }} </span>
											}
										</p>
									}
								}
							</div>
						</div>
					</div>
					<div
						class="add-button-wrapper hmf-display-flex hmf-justify-content-end hmf-ml-s hmf-ml-md-m">
						<button
							hmf-button
							class="add-button"
							[variant]="'secondary'">
							Add
						</button>
					</div>
				</div>
			</div>
		}
	</div>
}
